const RestaurantFoodTemplate = (food) => {
  return `
    <div class="food">
      <div class="image">
        <picture>
          <source media="(max-width: 780px)" srcset="./assets/food-small.jpg">
          <img
            class="lazyload" 
            data-src="/assets/food-large.jpg"
            alt="${food.name}"
          >
        </picture>
      </div>
      <div class="name-rating-category">
        <div class="name">${food.name}</div>
        <div class="category">chicken . thai . spicy</div>
        <div class="rating"><i class="fa fa-star" aria-hidden="true"></i> 9.3</div>
      </div>
    </div>
  `
}

export default RestaurantFoodTemplate
